import { routerMiddleware } from 'react-router-redux';
import { createBrowserHistory } from 'history';

export const history = createBrowserHistory();
export const connectedRouterMiddleware = routerMiddleware(history);



// WEBPACK FOOTER //
// ./app/javascript/pro_platform/store/router.js